import {connect} from 'react-redux'
import styles from './List.css'
import InfiniteScroll from 'react-infinite-scroller'
import {
  recipesRequest,
  onClickRow
} from 'actions/ingredients/recipes'
import {getFormValues, isDirty} from 'redux-form'
import _ from 'lodash'
import {askConfirmAction} from 'actions/confirm-action'

class List extends React.Component {
  static INGREDIENTS = 'ingredients'
  static ITEMS = 'items'
  render () {
    return (
      this._hasData() && <div className={styles['wrapper']}>
        <table className={styles['table-header']}>
          {this._renderRecipesHeader()}
        </table>
        <div className={`${styles['table-content-wrapper']} recipes-table-content-wrapper`}>
          <InfiniteScroll
            pageStart={1}
            loadMore={this._onReachBottom}
            hasMore={this._hasMore()}
            useWindow={false}
            threshold={10}
            initialLoad={false}
          >
            <table className={`${styles['table-content']}`}>
              {this._renderRecipesTable()}
            </table>
          </InfiniteScroll>
        </div>
      </div>)
  }

  _renderRecipesHeader = () => {
    return <thead>
      <tr>
        <th>Item name</th>
        <th className='text-center'>Variant</th>
        <th className='text-center'>Ingredient</th>
        <th className='text-center'>Ingredient Stock Alert</th>
      </tr>
    </thead>
  }

  _renderRecipesTable = () => {
    const {recipes, recipesDetail} = this.props

    return <tbody>
      {recipes.map((recipe) => {
        const className = `${(recipesDetail && recipesDetail.id === recipe.id) ? styles.selected : ''}`
        let stockAlerts = this._stockAlertFormatter(recipe.recipe_ingredients)
        return <tr onClick={() => { this._onClickRowRecipes(recipe) }} className={className}>
          <td>{recipe.item_name}</td>
          <td className='text-center'>{recipe.item_variant_name}</td>
          <td className='text-center'>{`${recipe.recipe_ingredients && recipe.recipe_ingredients.length} ingredients`}</td>
          <td className={`text-center`}>
            {stockAlerts && stockAlerts.map(function (stockAlert, index) {
              return <span>
                <span className={`${stockAlert.className}`}>
                  {stockAlert.content}
                </span>
                {index === 0 && stockAlerts.length > 1 ? ', ' : ''}
              </span>
            })}
          </td>
        </tr>
      })}
    </tbody>
  }

  _hasMore = () => {
    const {currentPage, totalPage} = this.props
    return currentPage < totalPage
  }

  _onReachBottom = () => {
    const {dispatch, currentPage, recipes, search: {search}} = this.props
    const params = {
      page: currentPage + 1,
      keyword: search
    }
    dispatch(recipesRequest(params, recipes))
  }

  _itemNameRecipes = (recipes) => {
      // check apakah semua itemnya sama
    const itemIds = _.countBy(recipes.history_details, 'item_id')
    if (Object.keys(itemIds).length > 1) {
      return `${recipes.history_details.length} items`
    } else {
      if (!recipes.history_details[0].item_variant_name) {
        return `${recipes.history_details[0].item_name}`
      } else {
        return `${recipes.history_details[0].item_name} (${recipes.history_details.length} variants)`
      }
    }
  }

  _onClickRowRecipes = (recipes) => {
    const {dispatch, isDirtyForm} = this.props
    if (isDirtyForm) {
      dispatch(askConfirmAction(onClickRow(recipes)))
    } else {
      dispatch(onClickRow(recipes))
    }
  }

  _hasData = () => {
    const {recipes} = this.props
    return recipes.length > 0
  }

  _stockAlertFormatter = (ingredients) => {
    if (ingredients && ingredients.length <= 0) return ''
    let lowStock = 0
    let outStock = 0
    let result = []
    $.each(ingredients, function (i, ingredient) {
      if (ingredient.alert && ingredient.in_stock > 0 && ingredient.in_stock <= ingredient.stock_alert) lowStock += 1
      if (ingredient.alert && ingredient.in_stock <= 0) outStock += 1
    })
    if (lowStock > 0) {
      result.push({content: `${lowStock} Low`, className: 'stockAllertLow'})
    }
    if (outStock > 0) {
      result.push({content: `${outStock} Out`, className: 'stockAllertOut'})
    }
    return result
  }
}

function mapStateToProps (state) {
  const {
    recipes,
    recipesDetail,
    currentPage,
    totalPage,
    outlets
  } = state.ingredients.recipes
  let {showLoadingSpinnerPage} = state.loadingSpinner
  return {
    recipes,
    recipesDetail,
    currentPage,
    totalPage,
    showLoadingSpinnerPage,
    search: getFormValues('search')(state),
    isDirtyForm: isDirty('recipes')(state),
    outlets
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

List.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Recipes/List/List.js